import Alert from 'react-bootstrap/Alert'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { updateOwnProfile } from '../../../types'
import { formSubmit } from '../api/actionApiCall'
import { useAuth } from '../auth/AuthContext'
import { SubmitButton, TextField, useFormState } from '../components/form'

/**
 * Platební údaje uživatele. Číslo účtu odsud se použije, když si někdo ze
 * skupiny nechá vygenerovat QR kód na úhradu dluhu vůči tomuto uživateli.
 */
export function PaymentSettingsPage() {
    const { user, setUser } = useAuth()

    const form = useFormState({
        initialValues: {
            bankAccount: user?.bankAccount ?? '',
            bankAccountHolder: user?.bankAccountHolder ?? '',
        },
        onSubmit: async (values) => {
            const { data, fieldErrors } = await formSubmit(
                () =>
                    updateOwnProfile({
                        body: { bankAccount: values.bankAccount.trim(), bankAccountHolder: values.bankAccountHolder.trim() },
                    }),
                { successMessage: 'Platební údaje byly uloženy.' },
            )

            if (!data) {
                return { fieldErrors }
            }

            setUser(data)
            form.reset({ bankAccount: data.bankAccount ?? '', bankAccountHolder: data.bankAccountHolder ?? '' })
        },
    })

    return (
        <Row className="justify-content-center">
            <Col xs={12} sm={10} md={8} lg={6}>
                <Card className="mt-3">
                    <Card.Body>
                        <h1 className="h4 mb-3">Platební údaje</h1>

                        <p className="text-secondary small">
                            Z čísla účtu se ostatním ve skupině nabídne platební QR kód na úhradu toho, co vám dluží.
                            Vidí ho jen členové skupiny, ve které máte nevyrovnanou pohledávku.
                        </p>

                        <form onSubmit={form.handleSubmit} noValidate>
                            <TextField
                                label="Číslo účtu"
                                value={form.values.bankAccount}
                                onChange={(value) => form.setValue('bankAccount', value)}
                                error={form.fieldErrors.bankAccount}
                                helpText="Například 19-2000145399/0800. Předčíslí můžete vynechat, zadat jde i IBAN."
                                placeholder="19-2000145399/0800"
                                inputMode="text"
                                autoComplete="off"
                            />
                            <TextField
                                label="Jméno příjemce"
                                value={form.values.bankAccountHolder}
                                onChange={(value) => form.setValue('bankAccountHolder', value)}
                                error={form.fieldErrors.bankAccountHolder}
                                helpText={`Nepovinné. Bez vyplnění se použije „${user?.displayName ?? ''}".`}
                                autoComplete="name"
                            />

                            {!user?.bankAccount && (
                                <Alert variant="secondary" className="py-2 small">
                                    Dokud číslo účtu nevyplníte, QR platbu vám ostatní vygenerovat nemohou - dluh vám
                                    ale můžou zaplatit i jinak a zaznamenat ho ručně.
                                </Alert>
                            )}

                            <div className="d-flex gap-2">
                                <SubmitButton submitting={form.submitting}>Uložit</SubmitButton>
                            </div>
                        </form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}
